import api from './api';

class AdminService {
    // Get dashboard statistics
    async getDashboardStats() {
        try {
            const response = await api.get('/admin/dashboard/stats');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get customer analytics
    async getCustomerAnalytics(period = '30d') {
        try {
            const response = await api.get(`/admin/analytics/customers?period=${period}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get content analytics
    async getContentAnalytics(period = '30d') {
        try {
            const response = await api.get(`/admin/analytics/content?period=${period}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get product analytics
    async getProductAnalytics(period = '30d') {
        try {
            const response = await api.get(`/admin/analytics/products?period=${period}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get all registered customers
    async getCustomers() {
        try {
            const response = await api.get('/admin/customers');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }
}

export default new AdminService();